import { useCallback, useMemo } from 'react';

import {
    ApplePayProvisionData,
    postMessageRN,
    useReactNativeProps,
    WebToRNAction,
} from '@eika-infrastruktur/mobilbank-lib';

export const useOnboardToAppleWallet = () => {
    const nativeProps = useReactNativeProps();

    const enabled = useMemo(() => nativeProps.supports?.applePay, [nativeProps]);

    return useCallback(
        (provisionPayload: ApplePayProvisionData | null) => {
            if (!enabled || !provisionPayload) return;

            postMessageRN({ action: WebToRNAction.APPLE_PAY_PROVISION, payload: provisionPayload });
        },
        [enabled],
    );
};
